import AddAttachment from "./add-attachment";
import Attachment from "./attachment";

type AttachmentsProps = {
    handleAttachmentChange: any,
    uploadedFiles: any[],
    reloadAttachment: any,
    removeAttachmentHandler: any,
    isMobile?: boolean,
    showAddButton?: boolean,
    showTitle?: boolean
}

const Attachments = (props: AttachmentsProps) => {
    const {
        handleAttachmentChange,
        uploadedFiles,
        removeAttachmentHandler,
        isMobile = false,
        showAddButton = true,
        showTitle = false
    } = props;

    const cssName = "attachments" + (uploadedFiles.length ? " has-attachments" : "");

    const shouldShowTitle = showTitle && !uploadedFiles.length;

    return (
        <>
            {!shouldShowTitle && <ul className={cssName}>
                {uploadedFiles.length > 0 && <>
                    {uploadedFiles.map((file: any, index: number) => (
                        <Attachment
                            key={index}
                            file={file}
                            removeAttachmentHandler={removeAttachmentHandler.bind(null, file.name)}
                        />))}
                </>}
            </ul>}

            {shouldShowTitle && <h6>Add Attachment</h6>}

            {showAddButton && <AddAttachment
                handleAttachmentChange={(e: any) => handleAttachmentChange(e.currentTarget.files)}
                isMobile={isMobile} />}
        </>
    );
}

export default Attachments;
